var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRealPhotoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 0C0.716 0 0 0.716 0 1.6V14.4C0 15.284 0.716 16 1.6 16H19.2C20.084 16 20.8 15.284 20.8 14.4V1.6C20.8 0.716 20.084 0 19.2 0H1.6ZM16.8 2.4C17.684 2.4 18.4 3.116 18.4 4C18.4 4.884 17.684 5.6 16.8 5.6C15.916 5.6 15.2 4.884 15.2 4C15.2 3.116 15.916 2.4 16.8 2.4ZM2.4 4L6.37812 7.97812L7.2 8.8L8.125 9.725C8.4626 10.0626 9.00771 10.0595 9.34531 9.72187C9.68371 9.38427 9.68371 8.83527 9.34531 8.49687L8.42344 7.57656L9.6 6.4L11.9781 8.77812L13.725 10.525C14.0626 10.8626 14.6077 10.8595 14.9453 10.5219C15.2837 10.1843 15.2837 9.63527 14.9453 9.29687L14.8234 9.17656L16 8L18.4 10.4V13.6H2.4V4Z",
    fill: "#B0B5BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealPhotoIcon);
export default __webpack_public_path__ + "static/media/real-photo-icon.1cca7150d8b8e7c8001b9b59d4d60427.svg";
export { ForwardRef as ReactComponent };